module.exports = __webpack_public_path__ + "static/img/yuandian.d6aef8a.png";